import { dtoToRgObject } from "@project-rouge/rg-aggregator";
import type { RgWorld, RgWorldDto } from "src/types/RgCorePackage";
import { Decompress } from "src/utils/Decompress";

// Decompress a zipped rgWorld payload (as emitted by the design-generator
// worker on `GeneratedItem.rgWorldZip`) back into a usable RgWorld for
// re-rendering, re-costing, or hydration.
export function RgWorldFromZip(zip: Uint8Array): RgWorld {
  const dto = Decompress<RgWorldDto>(zip);
  return dtoToRgObject<RgWorld>(dto);
}
